/**
 * The dashboard role switched on in this browser tab.
 * API writes store it on each change so a person with several roles
 * is recorded as the role that was active, not as Teacher by default.
 * Kept off the server so one request cannot leak into another.
 */

export const ACTIVE_ROLE_HEADER = "X-Active-Role";

let activeRole: string | null = null;

export function setActiveRoleApiHeader(role: string | null): void {
  if (typeof window === "undefined") return;
  const trimmed = role?.trim() ?? "";
  activeRole = trimmed || null;
}

export function getActiveRoleApiHeader(): string | null {
  if (typeof window === "undefined") return null;
  return activeRole;
}

/** Header for the current browser tab. Empty on the server and before a role is set. */
export function getActiveRoleRequestHeaders(): Record<string, string> {
  const role = getActiveRoleApiHeader();
  if (!role) return {};
  return { [ACTIVE_ROLE_HEADER]: role };
}
